var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"max-width":"1200"}},[_c('Breadcrumbs',{attrs:{"items":_vm.breadcrumbsItems}}),_c('top-info-action',{attrs:{"principal-btn-title":"Nueva orden","subtitle":"Crea y visualiza tus ordenes para proveedor y almacén","title":"Gestión de ordenes"},on:{"setDefaultPrimaryAction":_vm.createNewStore}}),_c('orders-resume')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }